import { Session } from "./JobQueue";

export interface PermissionType {
  name: string;
  description: string | null;
  id: string;
}
export interface RoleType {
  id: string;
  name: string;
  permissions: string[];
  isAdmin: boolean;
  isService: boolean;
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
  deletedAt: string | null;
}
export interface GroupType {
  name: string;
  description: string | null;
  id: string;
}
export type Permission = Omit<PermissionType,'id'>
export type Role = Omit<RoleType,'id'>
export type Group = Omit<GroupType,'id'>

export interface UserTypeType {
  name: string;
  id: string;
}
export interface UserStatusType {
  name: string;
  id: string;
}
export interface UserTypeType {
  name: string;
  id: string;
}
export interface UserType {
  id: string;
  name: string;
  email: string;
  note: string | null;
  lastLogin: string;
  loginCount : number | null;
  role : Role;
  isGuest : boolean;
  userStatus: UserStatusType;
  session : Session;
  analysisTypePermissions : string[];
  permissions : Permission[]
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  // groups: Group[]|null;
  // accessIp: string | null;
  // passwordChanged : string;
}

export type User = Omit<UserType,'id'>;
export type UserPostBody = Omit<
  UserType,
  | 'id'
  | 'createdAt'
  | 'updatedAt'
  | 'deletedAt'
  | 'lastLogin'
  | 'loginCount'
  | 'session'
  | 'permissions'
  | 'analysisTypePermissions'
  | 'isDeleted'
> & {
  role: { id: string };
  userStatus: { id: string };
};
export type UserPatchBody = Partial<
  Omit<
    UserType,
    | 'id'
    | 'createdAt'
    | 'updatedAt'
    | 'deletedAt'
    | 'session'
    | 'isDeleted'
    | 'lastLogin'
    | 'loginCount'
  >
> & {
  role?: { id: string };
  userStatus?: { id: string };
};

export interface UserRoleType {
  user: UserType;
  role: RoleType;
}

export interface UserGroupType {
  user: UserType;
  group: GroupType;
}

export interface PermissionRoleType {
  role: RoleType;
  permission: PermissionType;
}

export interface PermissionGroupType {
  group: GroupType;
  permission: PermissionType;
}

export interface LoginReq {
  userName: string;
  password: string;
}

export interface LoginRes {
  token: string;
  refreshToken: string;
  tokenExpires: BigInt;
  user: User;
  apiVersion: string;
}

export interface TokenStore {
  accessToken: string;
  refreshToken: string;
}

// export interface UserReqBody {
//   user_email?: string;
//   user_name?: string;
//   password?: string;
//   oldPassword?: string;
//   firstName?: string;
//   lastName?: string;
//   role?: {
//     id: User['type']['id'];
//   };
// }

export interface UpdateMeReqBody {
  user_name: string;
  oldPassword: string;
  password: string;
}

export interface BaseUserSchema {
  email: string;
  password: string;
  name: string;
  isGuest: boolean;
  userStatus?: {
    id: string;
  };
  role?: {
    id: string;
  };
  note?: string;
}

export enum UserStatusId {
  Active = "000000000000000000001000",
  Deactive = "000000000000000000001001",
}

export enum UserRoleId {
  SuperUser = "000000000000000000000001",
  AppService = "000000000000000000000002",
  Admin = "000000000000000000000003",
  User = "000000000000000000000004",
}

export const initialBaseUser: BaseUserSchema = {
  email: "",
  password: "",
  name: "",
  isGuest: false,
  userStatus: {
    id: UserStatusId.Active,
  },
  role: {
    id: UserRoleId.User,
  },
  note: "",
};

export interface UserSchema extends Omit<BaseUserSchema, "role" | "userStatus"> {
  userStatus?: {
    id: string;
    name: string;
  };
  role?: {
    id: string;
    name: string;
    description: string;
  };
  id: string;
  loginCount: number;
  sessions: any[];
  analysisTypePermissions: any[];
  permissions: any[];
  isDeleted: boolean;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UserRes {
  data : UserSchema[];
  hasNextPage: boolean;
  count: number;
  apiVersion: string;
}
